import type { cardApiSpec } from "@wingspanhq/wingspan-api-types";
import { selectorWalletCards } from "../../Wallet/selectors/selectorWalletCards";

export const selectorVirtualWalletCard = (
  cards: cardApiSpec.Card[]
): cardApiSpec.Card | undefined =>
  selectorWalletCards(cards).find(card => card.isVirtualCard);
